import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

const COLORS = {
  sage: '#8FA89E',
  charcoal: '#2d2d2d',
  lightGray: '#f9f9f9',
  cream: '#F5F2EA'
};

const StorePage = () => {
  const navigate = useNavigate();

  const handleApplyClick = () => {
    navigate('/apply');
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: COLORS.cream }}>
      
      {/* TOP NAV */}
      <nav className="py-6 px-4 text-center" style={{ borderBottom: '1px solid #e5e5e5' }}>
        <h1 className="text-2xl sm:text-3xl font-bold mb-1" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
          Reset with Larrisa
        </h1>
        <p className="text-xs sm:text-sm" style={{ color: '#999' }}>1:1 Online Coaching. Australia</p>
      </nav>

      {/* HERO */}
      <section className="py-8 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-3 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}
          >
            You don't need more discipline.<br />
            You need someone to finally see you.
          </h2>
          
          <p className="text-sm sm:text-base mb-6 max-w-3xl mx-auto" style={{ color: '#666', lineHeight: '1.6' }}>
            A personalised 8 week program for women who are done starting over. Combining training, nutrition, and the mindset work most coaches skip entirely.
          </p>
          
          {/* Stats Badges - More Visual */}
          <div className="max-w-lg mx-auto mb-6">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center">
                  <p className="text-3xl font-bold" style={{ color: COLORS.sage }}>10+</p>
                  <p className="text-xs" style={{ color: '#666' }}>Years coaching</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold" style={{ color: COLORS.sage }}>100%</p>
                  <p className="text-xs" style={{ color: '#666' }}>Personalised</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold" style={{ color: COLORS.sage }}>8</p>
                  <p className="text-xs" style={{ color: '#666' }}>Week program</p>
                </div>
                <div className="text-center">
                  <p className="text-3xl font-bold" style={{ color: COLORS.sage }}>3</p>
                  <p className="text-xs" style={{ color: '#666' }}>Pillars</p>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handleApplyClick}
            className="px-8 py-3 text-sm sm:text-base font-semibold rounded-lg hover:opacity-90 transition-all shadow-lg"
            style={{ backgroundColor: COLORS.sage, color: 'white' }}
          >
            Apply for your free discovery call
          </button>
        </div>
      </section>

      {/* CLIENT RESULTS - COMPACT GRID */}
      <section className="py-8 px-4" style={{ backgroundColor: 'white' }}>
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl sm:text-3xl font-bold mb-6 text-center" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
            Real Results
          </h3>
          
          {/* 2x2 Grid - Compact */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            <div className="rounded-lg overflow-hidden" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <img
                src="https://customer-assets.emergentagent.com/job_mum-method-design/artifacts/1m5bgbxq_IMG_0091.jpeg"
                alt="Client transformation"
                className="w-full h-full object-cover"
                style={{ aspectRatio: '1/1' }}
              />
            </div>
            
            <div className="rounded-lg overflow-hidden" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <img
                src="https://customer-assets.emergentagent.com/job_mum-method-design/artifacts/32qmfd3f_IMG_0092.jpeg"
                alt="Client transformation"
                className="w-full h-full object-cover"
                style={{ aspectRatio: '1/1' }}
              />
            </div>
            
            <div className="rounded-lg overflow-hidden" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <img
                src="https://customer-assets.emergentagent.com/job_mum-method-design/artifacts/h7wh5n0z_IMG_0082.jpeg"
                alt="Client transformation"
                className="w-full h-full object-cover"
                style={{ aspectRatio: '1/1' }}
              />
            </div>
            
            <div className="rounded-lg overflow-hidden" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <img
                src="https://customer-assets.emergentagent.com/job_mum-method-design/artifacts/vqj48lgs_IMG_0079.jpeg"
                alt="Client transformation"
                className="w-full h-full object-cover"
                style={{ aspectRatio: '1/1' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-8 px-4" style={{ backgroundColor: 'white' }}>
        <div className="max-w-3xl mx-auto">
          <h3 className="text-2xl sm:text-3xl font-bold mb-6 text-center" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
            What clients say
          </h3>
          
          <div className="space-y-6">
            {/* Mel Anne */}
            <div className="bg-white rounded-lg p-6" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <p className="text-sm sm:text-base mb-3 italic" style={{ color: COLORS.charcoal, lineHeight: '1.6' }}>
                I honestly can't recommend Riss enough. From the start, she just kept it real. No pressure, no over the top expectations. Just someone who genuinely gets that starting out (or getting back into it) can feel pretty intimidating.
              </p>
              <p className="text-xs font-semibold text-right" style={{ color: COLORS.sage }}>
                Mel Anne
              </p>
            </div>

            {/* Tash */}
            <div className="bg-white rounded-lg p-6" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <p className="text-sm sm:text-base mb-3 italic" style={{ color: COLORS.charcoal, lineHeight: '1.6' }}>
                I can't recommend Larissa as a coach highly enough. She took time to understand my goals and lifestyle to create a program that felt realistic and tailored specifically for me. She guided me through both workouts and nutrition in a way that actually made sense and didn't feel overwhelming. Now I feel comfortable doing it all on my own, which says a lot about how she trains. She's not about keeping you dependent, she actually wants you to feel confident and capable.
              </p>
              <p className="text-xs font-semibold text-right" style={{ color: COLORS.sage }}>
                Tash
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SOUND FAMILIAR */}
      <section className="py-8 px-4" style={{ backgroundColor: 'white' }}>
        <div className="max-w-3xl mx-auto">
          <h3 className="text-2xl sm:text-3xl font-bold mb-2 text-center" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
            Sound familiar?
          </h3>
          
          <p className="text-sm sm:text-base mb-4 text-center" style={{ color: '#666', lineHeight: '1.6' }}>
            You've tried everything. The problem isn't effort.
          </p>
          
          <p className="text-sm sm:text-base mb-4" style={{ color: '#666', lineHeight: '1.6' }}>
            You start programs and stop them. You drag yourself to the gym already running on empty. You tell yourself it's a discipline problem, but it's not. It's a subconscious story you've been carrying for years, one that says you don't deserve to prioritise yourself.
          </p>

          <div className="space-y-3">
            <div className="py-3 px-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <p className="text-sm" style={{ color: COLORS.charcoal }}>
                "I'm always failing. I don't even know where to start."
              </p>
            </div>
            
            <div className="py-3 px-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <p className="text-sm" style={{ color: COLORS.charcoal }}>
                "I'm exhausted, not just physically. Soul deep tired."
              </p>
            </div>
            
            <div className="py-3 px-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <p className="text-sm" style={{ color: COLORS.charcoal }}>
                "I feel guilty for wanting more. Everything looks fine from the outside."
              </p>
            </div>
            
            <div className="py-3 px-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <p className="text-sm" style={{ color: COLORS.charcoal }}>
                "I just need someone to tell me there's still a way through."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* THE RESET METHOD - THREE PILLARS */}
      <section className="py-8 px-4">
        <div className="max-w-5xl mx-auto">
          <h3 className="text-2xl sm:text-3xl font-bold mb-2 text-center" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
            The Reset Method
          </h3>
          
          <p className="text-sm sm:text-base mb-6 text-center max-w-2xl mx-auto" style={{ color: '#666', lineHeight: '1.6' }}>
            Three things working together, because one alone never sticks.
          </p>
          
          <p className="text-sm sm:text-base mb-6 text-center max-w-3xl mx-auto" style={{ color: '#666', lineHeight: '1.6' }}>
            Most programs give you the workout. Some add a meal plan. But they skip the part that's actually stopping you: what's running in the background of your mind.
          </p>

          <div className="grid grid-cols-1 gap-4">
            {/* Pillar 1 */}
            <div className="bg-white rounded-xl p-6" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <div className="text-4xl font-bold mb-3" style={{ color: COLORS.sage, opacity: 0.3 }}>01</div>
              <h4 className="text-lg font-bold mb-2" style={{ color: COLORS.charcoal }}>Body</h4>
              <p className="text-xs font-semibold mb-2" style={{ color: COLORS.sage }}>Training + nutrition</p>
              <p className="text-sm mb-3" style={{ color: '#666', lineHeight: '1.6' }}>
                Customised 4 week training blocks. Personalised macros and a 5 day meal structure. No templates, no one size fits all.
              </p>
              <div className="flex flex-wrap gap-2 text-xs" style={{ color: '#999' }}>
                <span className="px-2 py-1 rounded" style={{ backgroundColor: COLORS.cream }}>Via Trainerize</span>
                <span className="px-2 py-1 rounded" style={{ backgroundColor: COLORS.cream }}>Progressive overload weekly</span>
              </div>
            </div>

            {/* Pillar 2 */}
            <div className="bg-white rounded-xl p-6" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <div className="text-4xl font-bold mb-3" style={{ color: COLORS.sage, opacity: 0.3 }}>02</div>
              <h4 className="text-lg font-bold mb-2" style={{ color: COLORS.charcoal }}>Mind</h4>
              <p className="text-xs font-semibold mb-2" style={{ color: COLORS.sage }}>Subconscious reprogramming</p>
              <p className="text-sm mb-3" style={{ color: '#666', lineHeight: '1.6' }}>
                Breathwork, visualisation, and daily frameworks to rewire the patterns keeping you stuck. Taught 1:1 by Larrisa.
              </p>
              <div className="flex flex-wrap gap-2 text-xs" style={{ color: '#999' }}>
                <span className="px-2 py-1 rounded" style={{ backgroundColor: COLORS.cream }}>Breathwork</span>
                <span className="px-2 py-1 rounded" style={{ backgroundColor: COLORS.cream }}>Reset Method Ebook</span>
              </div>
            </div>

            {/* Pillar 3 */}
            <div className="bg-white rounded-xl p-6" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
              <div className="text-4xl font-bold mb-3" style={{ color: COLORS.sage, opacity: 0.3 }}>03</div>
              <h4 className="text-lg font-bold mb-2" style={{ color: COLORS.charcoal }}>Consistency</h4>
              <p className="text-xs font-semibold mb-2" style={{ color: COLORS.sage }}>Structure + accountability</p>
              <p className="text-sm mb-3" style={{ color: '#666', lineHeight: '1.6' }}>
                Twice weekly check ins throughout all 8 weeks. Midweek momentum and end of week review so you're never left to figure it out alone.
              </p>
              <div className="flex flex-wrap gap-2 text-xs" style={{ color: '#999' }}>
                <span className="px-2 py-1 rounded" style={{ backgroundColor: COLORS.cream }}>2x weekly check-ins</span>
                <span className="px-2 py-1 rounded" style={{ backgroundColor: COLORS.cream }}>Full 8 weeks</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EVERYTHING YOU GET */}
      <section className="py-8 px-4" style={{ backgroundColor: 'white' }}>
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl sm:text-3xl font-bold mb-2 text-center" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
            Everything you get
          </h3>
          
          <p className="text-sm sm:text-base mb-6 text-center" style={{ color: '#666' }}>
            Built for you. Not copied from a template.
          </p>

          <div className="grid grid-cols-1 gap-3">
            <div className="p-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <h4 className="text-sm font-bold mb-1" style={{ color: COLORS.charcoal }}>
                Initial 30 minute discovery call
              </h4>
              <p className="text-xs" style={{ color: '#666', lineHeight: '1.5' }}>
                Online or in person. We get clear on your goals, uncover your blocks, and build your personalised plan together.
              </p>
            </div>

            <div className="p-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <h4 className="text-sm font-bold mb-1" style={{ color: COLORS.charcoal }}>
                Personalised training program
              </h4>
              <p className="text-xs" style={{ color: '#666', lineHeight: '1.5' }}>
                4 week blocks, built around where you are right now. Delivered via Trainerize (free access included).
              </p>
            </div>

            <div className="p-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <h4 className="text-sm font-bold mb-1" style={{ color: COLORS.charcoal }}>
                Customised macros and high protein meal examples
              </h4>
              <p className="text-xs" style={{ color: '#666', lineHeight: '1.5' }}>
                Your exact macros plus an example 5 day meal plan with easy to prepare, high protein meals to suit your lifestyle.
              </p>
            </div>

            <div className="p-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <h4 className="text-sm font-bold mb-1" style={{ color: COLORS.charcoal }}>
                Breathwork and visualisation system
              </h4>
              <p className="text-xs" style={{ color: '#666', lineHeight: '1.5' }}>
                Taught 1:1 by Larrisa. Your daily practice for rewiring the subconscious patterns keeping you stuck.
              </p>
            </div>

            <div className="p-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <h4 className="text-sm font-bold mb-1" style={{ color: COLORS.charcoal }}>
                Signature Reset Method Ebook
              </h4>
              <p className="text-xs" style={{ color: '#666', lineHeight: '1.5' }}>
                Five daily frameworks: wake with intention, hydrate, visualise, move, reflect. The operating system for your reset.
              </p>
            </div>

            <div className="p-4 rounded-lg" style={{ backgroundColor: COLORS.cream }}>
              <h4 className="text-sm font-bold mb-1" style={{ color: COLORS.charcoal }}>
                Twice weekly check ins for all 8 weeks
              </h4>
              <p className="text-xs" style={{ color: '#666', lineHeight: '1.5' }}>
                Midweek for momentum and troubleshooting. End of week for progress review and program adjustments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WHO IS LARRISA */}
      <section className="py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl sm:text-3xl font-bold mb-6 text-center" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
            Who is Larrisa?
          </h3>

          <div className="flex flex-col items-center gap-6 text-center">
            <div className="flex-shrink-0">
              <img
                src="https://customer-assets.emergentagent.com/job_mum-method-design/artifacts/u15cc17y_IMG_5335.jpeg"
                alt="Larrisa"
                className="w-32 h-32 sm:w-40 sm:h-40 rounded-full object-cover mx-auto"
                style={{ 
                  boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                  transform: 'rotate(-8deg)'
                }}
              />
            </div>

            <div>
              <p className="text-sm mb-3" style={{ color: '#666', lineHeight: '1.6' }}>
                I'm a bank manager, a mum of three, and a qualified Personal Trainer, Nutrition Coach, Breathwork and Reiki Practitioner.
              </p>
              
              <p className="text-sm mb-3" style={{ color: '#666', lineHeight: '1.6' }}>
                I created this work because I needed it myself. I know what it feels like to give everything to everyone else and have nothing left. Movement saved my sanity, but I quickly learned that fitness alone wasn't enough. The real shift happened when I started working on what was underneath: the subconscious stories, the nervous system patterns, the buried belief that I didn't deserve to feel good.
              </p>
              
              <p className="text-sm mb-4" style={{ color: '#666', lineHeight: '1.6' }}>
                This isn't about perfection. It's about alignment. Getting your mind, your heart, and your body working together so you can finally stop starting over and start actually living.
              </p>

              <div className="flex flex-wrap justify-center gap-2 text-xs" style={{ color: '#999' }}>
                <span className="px-3 py-1 rounded-full" style={{ backgroundColor: COLORS.cream }}>PT</span>
                <span className="px-3 py-1 rounded-full" style={{ backgroundColor: COLORS.cream }}>Nutrition Coach</span>
                <span className="px-3 py-1 rounded-full" style={{ backgroundColor: COLORS.cream }}>Breathwork Practitioner</span>
                <span className="px-3 py-1 rounded-full" style={{ backgroundColor: COLORS.cream }}>Reiki Practitioner</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SCROLLING MARQUEE */}
      <section className="py-6 overflow-hidden" style={{ backgroundColor: COLORS.sage }}>
        <div className="flex whitespace-nowrap animate-scroll">
          <span className="text-xl sm:text-2xl font-bold mx-6" style={{ color: 'white' }}>
            Ready to stop starting over? &nbsp;&nbsp;&nbsp; Ready to stop starting over? &nbsp;&nbsp;&nbsp; Ready to stop starting over? &nbsp;&nbsp;&nbsp; Ready to stop starting over?
          </span>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-12 px-4">
        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-xl p-6 sm:p-8 text-center" style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
            <h3 className="text-xl sm:text-2xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif", color: COLORS.charcoal }}>
              The Reset Method. 1:1 Coaching
            </h3>
            
            <div className="my-4">
              <p className="text-3xl sm:text-4xl font-bold mb-2" style={{ color: COLORS.charcoal }}>
                $77 AUD / week
              </p>
              <p className="text-xs mb-3" style={{ color: '#888' }}>
                8 week minimum commitment. Australian clients only
              </p>
            </div>

            <div className="space-y-2 text-xs mb-6" style={{ color: '#666' }}>
              <p>✓ 30 min discovery call included</p>
              <p>✓ Personalised training and nutrition</p>
              <p>✓ Breathwork and mindset work</p>
              <p>✓ Reset Method Ebook</p>
              <p>✓ Twice weekly check ins</p>
            </div>

            <button
              onClick={handleApplyClick}
              className="w-full px-8 py-3 text-sm sm:text-base font-semibold rounded-lg hover:opacity-90 transition-all shadow-lg mb-3"
              style={{ backgroundColor: COLORS.sage, color: 'white' }}
            >
              Apply for your free discovery call
            </button>
            
            <p className="text-xs" style={{ color: '#999' }}>
              No commitment required to apply. Just a conversation.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default StorePage;
